import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { withUser } from 'components/queries/GetUserQuery';
import CancelBookingCta from './CancelBookingCta';

export default injectIntl(withUser(withRouter(CancelBookingCta)));
